import { FC } from 'react';
import { useContextSelector as useCS } from 'use-context-selector';
import { Modal } from '@mui/material';
import { CloseIcon, HideOrShowAccountModalIcon } from 'assets';
import { profileConfigSelectors } from 'domain/profileConfig/selectors';
import {
  ProfileConfigContext,
  TProfileConfigContextState,
} from 'domain/profileConfig/ProfileConfigContext';
import { TUpdate } from 'domain/types';
import { Button } from 'view/components';
import * as CS from 'view/modals/styled';
import { useHideOrShowAccount } from 'view/pages/profile/hooks/useHideOrShowAccount';

const ProfileHideAccountModal: FC<{ hideCloseButton?: boolean }> = ({
  hideCloseButton = false,
}) => {
  const isOpenHideAccountModal: boolean = useCS(
    ProfileConfigContext,
    profileConfigSelectors.isOpenHideAccountModal
  );
  const update: TUpdate<TProfileConfigContextState> | undefined = useCS(
    ProfileConfigContext,
    profileConfigSelectors.update
  );

  const { isLoading, updateAccountPrivacy } = useHideOrShowAccount();

  const onClose = () => {
    if (update) update({ isOpenHideAccountModal: false });
  };

  const onHideClick = () => {
    updateAccountPrivacy({ showProfile: false });
  };

  return (
    <Modal
      open={isOpenHideAccountModal}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <CS.ModalMainWrapper>
        {!hideCloseButton ? (
          <CS.CloseIconBox onClick={onClose}>
            <CloseIcon />
          </CS.CloseIconBox>
        ) : null}
        <CS.ModalMainBox>
          <CS.ModalMainImage>
            <HideOrShowAccountModalIcon />
          </CS.ModalMainImage>
          <CS.ModalMainHeader>
            <CS.ModalMainHeaderTitle>Do you want to hide account?</CS.ModalMainHeaderTitle>
            <CS.ModalMainHeaderSubTitle>
              {
                'Your profile will not be available for viewing to all users \n and will not appear in the search results.'
              }
            </CS.ModalMainHeaderSubTitle>
          </CS.ModalMainHeader>
        </CS.ModalMainBox>
        <CS.ModalMainFooter>
          <Button
            className="red-button"
            variant="outlined"
            text="Hide My Account"
            onClick={onHideClick}
            disabled={isLoading}
            style={{ width: '100%', minHeight: '50px' }}
          />
          <Button variant="contained" text="Cancel" onClick={onClose} />
        </CS.ModalMainFooter>
      </CS.ModalMainWrapper>
    </Modal>
  );
};

export default ProfileHideAccountModal;
